const _excluded = ["to"],_excluded2 = ["children", "queryParams"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var s = Object.getOwnPropertySymbols(e);for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (e.includes(n)) continue;t[n] = r[n];}return t;}import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

const validProps = (props) => {
  const { to } = props,valid = _objectWithoutProperties(props, _excluded);
  return valid;
};

const CurrentLocationLink = (_ref) => {let { children, queryParams = {} } = _ref,otherProps = _objectWithoutProperties(_ref, _excluded2);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  Object.keys(queryParams).forEach((key) => {
    query.set(key, queryParams[key]);
  });

  query.forEach((value, key) => {
    if (value === '') {
      query.delete(key);
    }
  });

  return (/*#__PURE__*/
    React.createElement(Link, _extends({ to: `${location.pathname}?${query.toString()}` }, validProps(otherProps)),
    children
    ));

};






export { CurrentLocationLink };

export default CurrentLocationLink;